import { Box, Stack, Typography } from '@mui/material';

import { ODAnalysis } from 'state/originDestinationSlices';

import { StlCard } from 'appTypes';
import StlItemCard from 'features/common/StlItemCard/StlItemCard';

import { useODStatus } from '../hooks/useODStatus';
import ODCardMenu from './ODCardMenu';

import styles from './ODCard.module.css';

export default function ODCard({
  item: analysis,
  selected,
  fullWidth,
}: StlCard<ODAnalysis>) {
  const status = useODStatus(analysis);
  const { name, start_date, end_date, tt_seg_ids, has_volume } = analysis;

  const segNumb = tt_seg_ids?.length;
  let metric = 'Loading';
  if (status === 'done') {
    metric = has_volume ? 'Volumes' : 'Proportions';
  }
  return (
    <StlItemCard<ODAnalysis>
      itemType="analysis"
      status={status}
      item={analysis}
      selected={selected}
      fullWidth={fullWidth}
      secondaryLine={`${segNumb} segment${segNumb !== 1 ? 's' : ''}`}
      name={name}
      menu={<ODCardMenu analysis={analysis} />}
    >
      <Stack
        className={styles.time_duration_box}
        data-selected={selected}
        data-fullwidth={fullWidth}
      >
        <Stack display="flex">
          <Typography variant="caption" className={styles.op8}>
            Metric
          </Typography>
          <Typography variant="caption" className={styles.txt_data}>
            {metric}
          </Typography>
        </Stack>

        <Box className={styles.time_duration_inner_box}>
          <Typography variant="caption" className={styles.op8}>
            Time Period
          </Typography>
          <Typography variant="caption" className={styles.txt_data}>
            {start_date} to {end_date}
          </Typography>
        </Box>
      </Stack>
    </StlItemCard>
  );
}
